import { useEffect, useState } from "react";
import api from "../utils/api";
import { API_ENDPOINTS } from "../utils/urls";
import Navbar from "../components/Navbar";
import AddInventoryItem from "../components/AddItem.inventory";
import AddAddons from "../components/Addon.inventory";
import ItemCard from "../components/InventoryCard";
import AddOnCard from "../components/addOns.card";
import AddCategory from "../components/AddCategory.inventory";
import Footer from "../components/Footer";
import EditAddOn from "../components/EditAddOn.inventory";
import EditItem from "../components/EditItem.Inventory";

export default function Inventory() {
  const [inventoryItems, setInventoryItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [addOns, setAddOns] = useState([]);
  const [showInventoryForm, setshowInventoryForm] = useState(false);
  const [showEditInventoryForm, setshowEditInventoryForm] = useState(false);
  const [showAddonForm, setshowAddonForm] = useState(false);
  const [showEditAddonForm, setshowEditAddonForm] = useState(false);
  const [showCategoryForm, setShowCategoryForm] = useState(false);
  const [viewMode, setViewMode] = useState("all");
  const [selectedAddOn, setSelectedAddOn] = useState<any>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const handleEditAddOn = (addon: any) => {
    setSelectedAddOn(addon); // Set the add-on for editing
    setshowEditAddonForm(true); // Show the form
  };

  const handleEditItem = (item: any) => {
    setSelectedItem(item); // Set the add-on for editing
    setshowEditInventoryForm(true); // Show the form
  };

  const getInventoryData = async () => {
    try {
      const res = await api.get(API_ENDPOINTS.INVENTORY.GET_DATA);
      setInventoryItems(res.data.data);
      setCategories(res.data.categories);
      setAddOns(res.data.addOns);
    } catch (error) {
      console.error("Error fetching inventory data:", error);
    }
  };

  useEffect(() => {
    getInventoryData();
  }, []);

  const categorizedGroups = categories.map((category: any) => ({
    categoryName: category.name,
    items: inventoryItems.filter(
      (item: any) => item.categoryId === category.categoryId
    ),
  }));

  // Get uncategorized items (no matching categoryId or null/undefined)
  const uncategorizedItems = inventoryItems.filter(
    (item: any) =>
      !item.categoryId ||
      !categories.some((cat: any) => cat.categoryId === item.categoryId)
  );

  // Combine categorized + uncategorized (if any)
  const groupedItems = [
    ...categorizedGroups.filter((group) => group.items.length > 0),
    ...(uncategorizedItems.length > 0
      ? [{ categoryName: "No Category", items: uncategorizedItems }]
      : []),
  ];

  return (
    <div>
      <div className="p-8">
        <Navbar />
        <br />
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">Inventory</h1>
          <div>
            <button
              className="bg-blue-600 text-white px-4 py-2 rounded m-[10px]"
              onClick={() => setshowInventoryForm(true)}
            >
              + Add Item
            </button>
            <button
              className="bg-blue-600 text-white px-4 py-2 rounded m-[10px]"
              onClick={() => setshowAddonForm(true)}
            >
              + Add AddOns
            </button>
            <button
              className="bg-blue-600 text-white px-4 py-2 rounded m-[10px]"
              onClick={() => setShowCategoryForm(true)}
            >
              + Add Category
            </button>
          </div>
        </div>
        <select
          className="border p-2 rounded mb-6"
          value={viewMode}
          onChange={(e) => setViewMode(e.target.value)}
        >
          <option value="all">All Inventory Items</option>
          <option value="addons">AddOns</option>
          {categories.map((category: any) => (
            <option key={category.categoryId} value={category.categoryId}>
              {category.name}
            </option>
          ))}
        </select>
        {viewMode === "all" && (
          <div>
            {groupedItems.map((group: any) => (
              <div key={group.categoryName} className="mb-10">
                <h2 className="text-xl font-semibold mb-4">
                  {group.categoryName}
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                  {group.items.map((item: any) => (
                    <ItemCard
                      key={item.itemId}
                      item={item}
                      onEdit={(item) => handleEditItem(item)}
                    />
                  ))}
                </div>
              </div>
            ))}
            {addOns.length > 0 && (
              <div className="mt-12">
                <h2 className="text-xl font-semibold mb-4">Add-Ons</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                  {addOns.map((addon: any) => (
                    <div
                      key={addon.id}
                      className="border p-4 rounded shadow flex justify-between items-center"
                    >
                      <div>
                        <h3 className="font-bold text-lg">{addon.name}</h3>
                        <p>Price: ₹{addon.price}</p>
                        <p>Stock: {addon.stock}</p>
                        <p>SKU: {addon.sku}</p>
                      </div>
                      <button
                        onClick={() => handleEditAddOn(addon)}
                        className="bg-blue-600 text-white px-4 py-2 rounded ml-4"
                      >
                        Edit
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {viewMode === "addons" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {addOns.map((addOn: any) => (
              <AddOnCard key={addOn.id} addOn={addOn} />
            ))}
          </div>
        )}

        {viewMode !== "all" && viewMode !== "addons" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {inventoryItems
              .filter((item: any) => item.categoryId === viewMode)
              .map((item: any) => (
                <ItemCard key={item.itemId} item={item} />
              ))}
          </div>
        )}

        {showInventoryForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="bg-white w-full max-w-3xl max-h-[90vh] overflow-y-auto p-6 rounded shadow-lg relative">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-semibold">Add Items</h3>
                <button
                  className="bg-red-600 text-white px-4 py-2 rounded"
                  onClick={() => setshowInventoryForm(false)}
                >
                  X
                </button>
              </div>
              <AddInventoryItem
                setShowForm={setshowInventoryForm}
                categories={categories as []}
              />
            </div>
          </div>
        )}

        {showAddonForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="bg-white w-full max-w-3xl max-h-[90vh] overflow-y-auto p-6 rounded shadow-lg relative">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-semibold">Add Items</h3>
                <button
                  className="bg-red-600 text-white px-4 py-2 rounded"
                  onClick={() => setshowAddonForm(false)}
                >
                  X
                </button>
              </div>
              <AddAddons setShowForm={setshowAddonForm} />
            </div>
          </div>
        )}
        {showEditAddonForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="bg-white w-full max-w-3xl max-h-[90vh] overflow-y-auto p-6 rounded shadow-lg relative">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-semibold">Edit AddOn</h3>
                <button
                  className="bg-red-600 text-white px-4 py-2 rounded"
                  onClick={() => setshowEditAddonForm(false)}
                >
                  X
                </button>
              </div>
              <EditAddOn
                setShowForm={setshowAddonForm}
                editData={selectedAddOn}
              />
            </div>
          </div>
        )}

        {showEditInventoryForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="bg-white w-full max-w-3xl max-h-[90vh] overflow-y-auto p-6 rounded shadow-lg relative">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-semibold">Edit Items</h3>
                <button
                  className="bg-red-600 text-white px-4 py-2 rounded"
                  onClick={() => setshowEditInventoryForm(false)}
                >
                  X
                </button>
              </div>
              <EditItem
                setShowForm={setshowEditInventoryForm}
                editData={selectedItem}
              />
            </div>
          </div>
        )}

        {showCategoryForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="bg-white w-full max-w-3xl max-h-[90vh] overflow-y-auto p-6 rounded shadow-lg relative">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-semibold">Add Category</h3>
                <button
                  className="bg-red-600 text-white px-4 py-2 rounded"
                  onClick={() => setShowCategoryForm(false)}
                >
                  X
                </button>
              </div>
              <AddCategory setShowForm={setShowCategoryForm} />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
